import React from "react"
import propTypes from "prop-types"
import { graphql } from "gatsby"
import styled from "styled-components"

import SEO from "../components/Seo"
import MasonryComponent from "../components/MasonryComponent"

const Wrapper = styled.div`
  max-width: 960px;
  margin: 0 auto;
`

const CollectionsPage = ({ data }) => {
  const posts = data.allMarkdownRemark.edges
  return (
    <Wrapper>
      <SEO title="Collections" />
      {posts && <MasonryComponent posts={posts} type="page" />}
    </Wrapper>
  )
}

CollectionsPage.propTypes = {
  data: propTypes.shape({
    allMarkdownRemark: propTypes.shape({
      edges: propTypes.array,
    }),
  }).isRequired,
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "collections" } } }
      sort: { fields: frontmatter___order, order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            name
            featured
            order
          }
          fields {
            slug
          }
          id
        }
      }
    }
  }
`

export default CollectionsPage
